import RedactionDecision from 'components/AfterCopyright/EncyclopediaUnit/RedactionDecision';
import { useParams } from 'react-router-dom';

import AfterCopyrightDecisionForm from './AfterCopyrightDecisionForm';

function RedactionDecisionComponent() {
  const { offerID, committee, status } = useParams();
  const type = committee === 'eu_control' ? 0 : 1;
  return (
    <AfterCopyrightDecisionForm
      offerID={offerID}
      committee={committee}
      status={status}
    >
      <RedactionDecision
        offerID={offerID}
        type={type}
      />
    </AfterCopyrightDecisionForm>
  );
}
export default RedactionDecisionComponent;
